import React from 'react';
import PropTypes from 'prop-types';
import { BadgeList, Badge } from './Badge';

// Displays a list of the currently selected groups and locations
function CurrentDomains({ filters, setFilters }) {
  const groups = [];
  const locations = [];
  filters.domains?.forEach((item) => {
    if (item.className.includes('filter-group')) {
      groups.push(item);
    }
    if (item.className.includes('filter-location')) {
      locations.push(item);
    }
  });

  function removeDomain(location) {
    const newDomains = filters.domains.filter((domain) => {
      return domain.value !== location.value && domain.label !== location.label;
    });
    setFilters((prevFilters) => ({ ...prevFilters, domains: newDomains }));
  }

  function renderGroups(groups) {
    if (groups.length === 0) {
      return null;
    } else {
      return (
        <BadgeList title='Selected groups' maxLength={3}>
          {groups.map((group) => (
            <Badge
              label={group.label}
              key={group.value}
              removable={filters.domains.length > 1}
              onRemove={() => removeDomain(group)}
            />
          ))}
        </BadgeList>
      );
    }
  }

  function renderLocations(locations) {
    if (locations.length === 0) {
      return null;
    } else {
      return (
        <BadgeList title='Selected locations' maxLength={3}>
          {locations.map((location) => (
            <Badge
              label={location.label}
              key={location.value}
              removable={filters.domains.length > 1}
              onRemove={() => removeDomain(location)}
            />
          ))}
        </BadgeList>
      );
    }
  }

  return (
    <>
      {renderGroups(groups)}
      {renderLocations(locations)}
    </>
  );
}

CurrentDomains.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
};

export default CurrentDomains;
